import React, { useEffect, useMemo, useRef, useState } from "react";
import TableHeader from "../Table/TableHeader";
import { FieldArray, Formik } from "formik";
import editIcon from "../../Images/edit.svg";
import doneIcon from "../../Images/check.svg";
import cameraIcon from "../../Images/camera.svg";
import useListOptions from "../../CustomHooks/useListOptions";
import TableBodyWithInputs from "../Table/TableBodyWithInputs";
import SVGButton from "../Buttons/SVGButton";
import { write } from "../../DataApi/write";
import { useSession } from "../../authentications/SessionContext";
import { enqueueSnackbar } from "notistack";
import { handleResponse } from "../../utilities/handleResponse";
import useConfirmationModal from "../ConfirmationModal/useConfirmationModal";
import UploadedImage from "../UploadedImagedComponent/UploadedImage";
import { fileToBase64 } from "../../utilities/fileToBase64";
import { primaryColor } from "../../utilities/colors";
import RenderProductsVariantsListImage from "./RenderProductsVariantsListImage";
function ProductVariantDetails({
  productVariantList,
  record_id,
  variantsAttributesList,
}) {
  const { ConfirmationModal, setTitle, setMetaData, setOpenModal } =
    useConfirmationModal();
  const { setOptions, options, handleCustomSearch } = useListOptions();
  const { sessionInfo } = useSession();
  const { company_id, context, isVTEX } = sessionInfo;
  const image1920Ref = useRef();
  // console.log("productVariantList", productVariantList);
  const [editableIndex, seteditableIndex] = useState(-1);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleVarianChange = async (index, data) => {
    setIsSubmitting(true);
    const newChanges = {};
    const oldPayload = productVariantList[index];
    const newPayload = data;

    Object.keys(newPayload).forEach((key) => {
      if (JSON.stringify(newPayload[key]) !== JSON.stringify(oldPayload[key])) {
        newChanges[key] = newPayload[key];
      }
    });
    if (Object.keys(newChanges).length === 0) {
      seteditableIndex(-1);
      setIsSubmitting(false);

      return false;
    }
    let writeResponse = await write({
      id: data.id,
      change: newChanges,
      company_id,
      context,
      model: "product.product",
    });
    writeResponse = JSON.parse(writeResponse);
    setIsSubmitting(false);

    if (writeResponse?.result) {
      seteditableIndex(-1);
    } else {
      setOpenModal(true);
    }
    handleResponse({
      response: writeResponse,
      setMetaData,
      setTitle,
      successMessag: "Variant Updated Successfully",
    });
  };
  const handleChangeimage1920 = (e, index, data, setFieldValue, fullName) => {
    const file = e.target.files[0];
    if (file) {
      fileToBase64(file, (_, base64) => {
        setFieldValue(fullName, base64);
      });
    }
    if (
      file &&
      !["image/png", "image/jpeg", "image/svg+xml"].includes(file.type)
    ) {
      alert("Unsupported file type. Please select a PNG, JPG, or SVG file.");
      return;
    }
  };

  useEffect(() => {
    if (variantsAttributesList) {
      handleCustomSearch({
        model: "product.template.attribute.value",
        setState: setOptions,
        args: [["id", "in", variantsAttributesList]],
        pagination: { limit: variantsAttributesList?.length },
      }).then(() => {
        setIsLoading(false);
      });
    }
  }, [variantsAttributesList]);
  const tableHeaderList = useMemo(
    () => [
      {
        name: "image_1920",
        title: "Image",
        customRender: ({ ...props }) => (
          <RenderProductsVariantsListImage
            {...props}
            handleChangeimage1920={handleChangeimage1920}
            editableIndex={editableIndex}
          />
        ),
        containerClass: "p-2",
        inputClassName: "text-center",
        headerClassName: "text-center",
      },
      {
        name: "product_template_attribute_value_ids",
        title: "Variant",
        style: { minWidth: 150 },
        options: options || [],
        isMulti: true,
        disableInput: true,
        containerClass: "p-2",
        headerClassName: "text-center",
      },
      // {
      //   name: "volume",
      //   title: "Volume (cm³)",
      //   style: { maxWidth: 100 },
      //   type: "number",
      //   handleDisable: ({ index }) => index !== editableIndex,
      //   containerClass: "p-2",
      //   inputClassName: "text-center",
      //   headerClassName: "text-center",
      // },
      {
        name: "weight",
        title: "Weight (kg)",
        style: { maxWidth: 100 },
        type: "number",
        handleDisable: ({ index }) => index !== editableIndex,
        containerClass: "p-2",
        inputClassName: "text-center",
        headerClassName: "text-center",
      },
      {
        name: "ProHeight",
        title: "Height (cm)",
        style: { maxWidth: 100 },
        type: "number",
        handleDisable: ({ index }) => index !== editableIndex,
        containerClass: "p-2",
        inputClassName: "text-center",
        headerClassName: "text-center",
      },
      {
        name: "ProWidth",
        title: "Width (cm)",
        style: { maxWidth: 100 },
        type: "number",
        handleDisable: ({ index }) => index !== editableIndex,
        containerClass: "p-2",
        inputClassName: "text-center",
        headerClassName: "text-center",
      },
      {
        name: "ProLength",
        title: "Length (cm)",
        style: { maxWidth: 100 },
        type: "number",
        handleDisable: ({ index }) => index !== editableIndex,
        containerClass: "p-2",
        inputClassName: "text-center",
        headerClassName: "text-center",
      },
      {
        name: "standard_price",
        title: "Cost",
        style: { maxWidth: 100 },
        type: "number",
        handleDisable: ({ index }) => index !== editableIndex,
        containerClass: "p-2",
        inputClassName: "text-center",
        headerClassName: "text-center",
      },
      {
        name: "lst_price",
        title: "Price",
        style: { maxWidth: 100 },
        type: "number",
        disableInput: true,
        containerClass: "p-2",
        inputClassName: "text-center",
        headerClassName: "text-center",
      },
      {
        name: "price_extra",
        title: "Price Extra",
        style: { maxWidth: 100 },
        type: "number",
        handleDisable: ({ index }) => index !== editableIndex,
        containerClass: "p-2",
        inputClassName: "text-center",
        headerClassName: "text-center",
      },
      {
        customRender: ({ index, data }) => {
          return isSubmitting && index === editableIndex ? (
            <div
              className="loader"
              style={{ height: 25, width: 25, borderWidth: 5 }}
            />
          ) : (
            <SVGButton
              disabled={isSubmitting}
              hoverColor={isVTEX ? primaryColor.primary : "#ff5837"}
              icon={editableIndex === index ? "doneIcon" : "editIcon"}
              onClick={(e) => {
                e.stopPropagation();
                editableIndex === -1
                  ? seteditableIndex(index)
                  : editableIndex == index
                  ? handleVarianChange(index, data)
                  : seteditableIndex(index);
              }}
              className="me-2"
              type="button"
            />
          );
        },
        containerClass: "p-2",
        inputClassName: "text-center",
        headerClassName: "text-center",
      },
    ],
    [options, editableIndex, isSubmitting]
  );
  const vtexTableHeaderList = useMemo(
    () => [
      {
        name: "image_1920",
        title: "Image",
        customRender: ({ ...props }) => (
          <RenderProductsVariantsListImage
            {...props}
            handleChangeimage1920={handleChangeimage1920}
            editableIndex={editableIndex}
          />
        ),
        containerClass: "p-2",
        inputClassName: "text-center",
        headerClassName: "text-center",
      },
      {
        name: "name",
        title: "Name",
        style: { maxWidth: 100 },
        handleDisable: ({ index }) => index !== editableIndex,
        containerClass: "p-2",
        inputClassName: "text-center",
        headerClassName: "text-center",
      },
      {
        name: "product_template_attribute_value_ids",
        title: "Variant",
        style: { minWidth: 150 },
        options: options || [],
        isMulti: true,
        disableInput: true,
        containerClass: "p-2",
        headerClassName: "text-center",
      },
      {
        name: "barcode",
        title: "Barcode",
        style: { maxWidth: 100 },
        handleDisable: ({ index }) => index !== editableIndex,
        containerClass: "p-2",
        inputClassName: "text-center",
        headerClassName: "text-center",
      },
      {
        name: "default_code",
        title: "Reference Code",
        style: { maxWidth: 100 },
        handleDisable: ({ index }) => index !== editableIndex,
        containerClass: "p-2",
        inputClassName: "text-center",
        headerClassName: "text-center",
      },
      {
        name: "ProHeight",
        title: "Height (cm)",
        style: { maxWidth: 100 },
        type: "number",
        handleDisable: ({ index }) => index !== editableIndex,
        containerClass: "p-2",
        inputClassName: "text-center",
        headerClassName: "text-center",
      },
      {
        name: "ProWidth",
        title: "Width (cm)",
        style: { maxWidth: 100 },
        type: "number",
        handleDisable: ({ index }) => index !== editableIndex,
        containerClass: "p-2",
        inputClassName: "text-center",
        headerClassName: "text-center",
      },
      {
        name: "ProLength",
        title: "Length (cm)",
        style: { maxWidth: 100 },
        type: "number",
        handleDisable: ({ index }) => index !== editableIndex,
        containerClass: "p-2",
        inputClassName: "text-center",
        headerClassName: "text-center",
      },
      {
        name: "weight",
        title: "Weight (kgs)",
        style: { maxWidth: 100 },
        type: "number",
        handleDisable: ({ index }) => index !== editableIndex,
        containerClass: "p-2",
        inputClassName: "text-center",
        headerClassName: "text-center",
      },
      {
        name: "standard_price",
        title: "Cost",
        style: { maxWidth: 100 },
        type: "number",
        handleDisable: ({ index }) => index !== editableIndex,
        containerClass: "p-2",
        inputClassName: "text-center",
        headerClassName: "text-center",
      },
      {
        name: "lst_price",
        title: "Price",
        style: { maxWidth: 100 },
        type: "number",
        disableInput: true,
        containerClass: "p-2",
        inputClassName: "text-center",
        headerClassName: "text-center",
      },
      {
        name: "price_extra",
        title: "Price Extra",
        style: { maxWidth: 100 },
        type: "number",
        handleDisable: ({ index }) => index !== editableIndex,
        containerClass: "p-2",
        inputClassName: "text-center",
        headerClassName: "text-center",
      },
      {
        customRender: ({ index, data }) => {
          return isSubmitting && index === editableIndex ? (
            <div
              className="loader"
              style={{ height: 25, width: 25, borderWidth: 5 }}
            />
          ) : (
            <SVGButton
              disabled={isSubmitting}
              hoverColor={isVTEX ? primaryColor.primary : "#ff5837"}
              icon={editableIndex === index ? "doneIcon" : "editIcon"}
              onClick={(e) => {
                e.stopPropagation();
                editableIndex === -1
                  ? seteditableIndex(index)
                  : editableIndex == index
                  ? handleVarianChange(index, data)
                  : seteditableIndex(index);
              }}
              className="me-2"
              type="button"
            />
          );
        },
        containerClass: "p-2",
        inputClassName: "text-center",
        headerClassName: "text-center",
      },
    ],
    [options, editableIndex, isSubmitting]
  );
  return (
    <div className="table_container">
      <ConfirmationModal />
      <h4 className="pb-4 pt-2 text-center fw-bold">
        Product Variants Configuration
      </h4>
      <Formik
        enableReinitialize
        initialValues={{ atributes_list: productVariantList || [] }}
      >
        {({ values, setFieldValue }) => (
          <>
            <table>
              <TableHeader
                tableHeaderList={isVTEX ? vtexTableHeaderList : tableHeaderList}
              />
              <FieldArray
                name="atributes_list"
                render={({ ...props }) => (
                  <TableBodyWithInputs
                    {...props}
                    tableBodyList={
                      isVTEX ? vtexTableHeaderList : tableHeaderList
                    }
                    isLoadingData={isLoading}
                    setFieldValue={setFieldValue}
                  />
                )}
              />
            </table>
          </>
        )}
      </Formik>
    </div>
  );
}

export default ProductVariantDetails;
